import { Box, ClickAwayListener, Stack, Tooltip, Typography } from "@mui/material"
import NullCheck from "components/NullCheck"
import { currencyFormat } from "config/functions"
import { YESH_INVOICE_DOCUMENT_TYPE } from "containers/dashboard/const"
import { useEffect, useState } from "react"

const TooltipMonth = ({ bt, params, documents, isBuildCustomer }) => {
    const [openTooltip, setOpenTooltip] = useState(null)
    const id = params.id

    return (
        <ClickAwayListener onClickAway={() => setOpenTooltip(null)}>
            <Tooltip
                arrow
                placement="top"
                open={openTooltip === id}
                onClick={() => { }}
                disableHoverListener
                disableFocusListener
                disableTouchListener
                slotProps={{
                    tooltip: { sx: { minWidth: 250, backgroundColor: "bgPage.main", boxShadow: 5, p: 0 } },
                    arrow: { sx: { color: "bgPage.main", boxShadow: 5 } },
                }}
                title={
                    documents.length > 0
                        ? <Box maxHeight={250} sx={{ py: 0.5, overflowY: "scroll" }} p={1}>
                            {documents.map((doc, index) => {
                                const businessName =
                                    doc?.customerName ||
                                    doc?.CustomerName ||
                                    doc?.businessName ||
                                    doc?.ProviderName ||
                                    "-";

                                const amount =
                                    doc?.price ??
                                    doc?.Price ??
                                    doc?.TotalPrice ??
                                    0;

                                const docNumber =
                                    doc?.DocumentNumber ||
                                    doc?.docNumber

                                return (
                                    <Stack
                                        direction="row"
                                        key={doc?._id || doc?.id || index}
                                        justifyContent="space-between"
                                        alignItems="center"
                                        spacing={2}
                                        py={0.5}
                                        borderBottom={`${index === documents?.length - 1 ? "0px" : "1px"} solid #4b4b4b`}
                                    >
                                        <Stack>
                                            <Typography width="100%" fontSize={13}>
                                                {businessName}
                                            </Typography>

                                            <NullCheck valueForCheck={doc?.interval}>
                                                <Typography width="100%" fontSize={11}>
                                                    {`-${bt("EVERY")} ${doc?.interval} ${bt("MONTHS")}`}
                                                </Typography>
                                            </NullCheck>

                                            <NullCheck valueForCheck={docNumber}>
                                                <Typography width="100%" fontSize={11}>
                                                    {`${bt("DOCUMENT")}: ${docNumber} `}
                                                </Typography>
                                            </NullCheck>
                                        </Stack>

                                        <Typography
                                            color={
                                                doc?.DocumentType === YESH_INVOICE_DOCUMENT_TYPE.CREDIT_NOTE ||
                                                    amount < 0
                                                    ? "error.text"
                                                    : "success.main"
                                            }
                                            fontSize={13}
                                            fontWeight="bold"
                                        >
                                            {currencyFormat(amount)}
                                        </Typography>

                                    </Stack>
                                );
                            })}
                        </Box>
                        : ""
                }
            >
                <Typography
                    variant="body2"
                    color={isBuildCustomer && params?.formattedValue !== 0
                        ? params?.formattedValue > 0
                            ? "success.main"
                            : "error.text"
                        : "none"
                    }
                    fontWeight={params?.row?.id === "total" ? "bold" : "normal"}
                    onClick={() => setOpenTooltip(prev => prev === id ? null : id)
                    }
                >
                    {currencyFormat(params?.formattedValue)}
                </Typography>
            </Tooltip>
        </ClickAwayListener>
    )
}

export default TooltipMonth